/**
 * ISO codes aligned with backend `normalize_content_language` (Phase 2 RAG kb lang).
 */

export const KB_CONTENT_LANGUAGE_ISO = [
  '',
  'fr',
  'en',
  'es',
  'de',
  'it',
  'pt',
  'nl',
  'zh-hans',
] as const

export type KbContentLanguageIsoOption = (typeof KB_CONTENT_LANGUAGE_ISO)[number]

export type KnowledgesKbTranslations = {
  autoOption: string
  langFr: string
  langEn: string
  langEs: string
  langDe: string
  langIt: string
  langPt: string
  langNl: string
  langZhHans: string
}

export function labelForKbIso(
  iso: string,
  kb: KnowledgesKbTranslations,
): string {
  switch (iso) {
    case '':
      return kb.autoOption
    case 'fr':
      return kb.langFr
    case 'en':
      return kb.langEn
    case 'es':
      return kb.langEs
    case 'de':
      return kb.langDe
    case 'it':
      return kb.langIt
    case 'pt':
      return kb.langPt
    case 'nl':
      return kb.langNl
    case 'zh-hans':
      return kb.langZhHans
    default:
      return iso || kb.autoOption
  }
}
